(() => {
  function initGallery(root) {
    if (root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    const tiles = [...root.querySelectorAll('[data-gallery-index]')];
    const items = [...root.querySelectorAll('.ms-gallery__item')];
    const dialog = root.querySelector('[data-gallery-dialog]');
    const image = root.querySelector('[data-gallery-image]');
    const position = root.querySelector('[data-gallery-position]');
    const progress = root.querySelector('[data-gallery-progress]');
    const loadButton = root.querySelector('[data-gallery-load]');
    const batch = Number(root.dataset.batchSize) || 24;
    let visible = Math.min(batch, items.length);
    let current = 0;
    let openingTile = null;
    let touchStart = null;

    function showImage(index) {
      current = (index + tiles.length) % tiles.length;
      const tile = tiles[current];
      position.textContent = `${current + 1} / ${tiles.length}`;
      image.alt = tile.querySelector('img').alt;
      image.src = tile.dataset.galleryFull;
    }

    function open(index, tile) {
      if (typeof dialog.showModal !== 'function') {
        window.location.href = tile.dataset.galleryFull;
        return;
      }
      openingTile = tile;
      showImage(index);
      dialog.showModal();
      root.querySelector('[data-gallery-close]').focus();
    }

    tiles.forEach((tile, index) => {
      tile.addEventListener('click', () => open(index, tile));
    });

    root.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    root.querySelector('[data-gallery-prev]').addEventListener('click', () => showImage(current - 1));
    root.querySelector('[data-gallery-next]').addEventListener('click', () => showImage(current + 1));

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      image.removeAttribute('src');
      if (openingTile && openingTile.isConnected) openingTile.focus({ preventScroll: true });
      openingTile = null;
    });

    dialog.addEventListener('touchstart', (event) => {
      if (event.touches.length === 1) {
        touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }
    }, { passive: true });

    dialog.addEventListener('touchend', (event) => {
      if (!touchStart || event.changedTouches.length !== 1) return;
      const deltaX = event.changedTouches[0].clientX - touchStart.x;
      const deltaY = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
        showImage(current + (deltaX < 0 ? 1 : -1));
      }
    }, { passive: true });

    loadButton.addEventListener('click', () => {
      const previous = visible;
      visible = Math.min(visible + batch, items.length);
      items.slice(previous, visible).forEach((item) => { item.hidden = false; });
      progress.textContent = `Showing ${visible} of ${items.length} photographs`;
      if (visible === items.length) loadButton.hidden = true;
      const firstNewTile = tiles[previous];
      if (firstNewTile) firstNewTile.focus();
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-ms-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
